<template>
    <div>
        <div :class="classes" @click="toggle()">
            <slot />
        </div>

        <portal to="modals">
            <transition name="fade">
                <modal
                    v-if="modalOpen"
                    @close="modalOpen = false"
                    class="modal--full  modal--full--teal"
                    :full="true"
                >
                    <div slot="wiggle" class="wiggle">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1132 175.83" class="white"><g><g><path style="fill-rule:evenodd;" d="M1132,0V175.83H0V79.23c18.71,1,21.35,22.34,42.05,20.89,21.9-1.53,20.23-25.48,42.13-27S107.77,95.52,129.68,94s20.23-25.47,42.13-27,23.59,22.41,45.5,20.88,20.23-25.48,42.13-27S283,83.24,304.93,81.71s20.23-25.47,42.13-27,23.58,22.41,45.49,20.88,20.23-25.48,42.14-27S458.27,71,480.18,69.44s20.23-25.48,42.14-27S545.9,64.84,567.81,63.3,588,37.83,610,36.29s23.58,22.41,45.49,20.88,20.23-25.48,42.14-27S721.16,52.56,743.07,51s20.23-25.48,42.14-27,23.59,22.41,45.5,20.87,20.23-25.47,42.13-27,23.59,22.41,45.5,20.88,20.23-25.48,42.14-27,23.58,22.4,45.49,20.87,20.24-25.48,42.15-27,23.59,22.41,45.5,20.87C1114.19,25,1114,3.86,1132,0Z"/></g></g></svg>
                    </div>

                    <div class="container px-4 md:px-0">
                        <div class="row flex-wrap">
                            <div class="col w-full md:w-full lg:w-3/5 text-white">
                                <h2 class="text-4xl" v-html="role"></h2>
                                <div class="copy" v-if="description" v-html="description"></div>
                                <accordion class="accordion--invert accordion--invert--teal mt-6" v-if="purpose">
                                    <h3 class="accordion__ttl" slot="header">Job Purpose</h3>
                                    <div slot="content">
                                        <div class="copy" v-html="purpose"></div>
                                    </div>
                                </accordion>
                                <accordion class="accordion--invert accordion--invert--teal" v-if="qualifications">
                                    <h3 class="accordion__ttl" slot="header">Qualifications and experience required</h3>
                                    <div slot="content">
                                        <div class="copy" v-html="qualifications"></div>
                                    </div>
                                </accordion>
                            </div>
                            <div class="col w-full md:w-full lg:w-2/5">
                                <div class="box  box--filled--white box--text--teal  box--h-auto">
                                    <div class="box__inner">
                                        <div class="box__content  box__content--left">
                                            <h2 class="text-teal text-3xl">Apply Now</h2>

                                            <vue-form handle="careers" :recaptcha-code=recaptcha  success-message="Thank you for applying!" classes="form  form--secondary mt-4" :values="{role: role}">
                                                <div slot-scope="{ data, errors, file }">
                                                    <div class="form__field">
                                                        <input type="text" name="name" id="name" class="form__input form__input--full" placeholder="Your Name" v-model="data.name">

                                                        <span class="form__error" v-if="typeof errors.name != 'undefined'" v-html="errors.name"></span>
                                                    </div>
                                                    <div class="form__field">
                                                        <input type="email" name="email" id="email" class="form__input form__input--full" placeholder="Your Email" v-model="data.email">

                                                        <span class="form__error" v-if="typeof errors.email != 'undefined'" v-html="errors.email"></span>
                                                    </div>
                                                    <div class="form__field">
                                                        <input type="text" name="phone" id="phone" class="form__input form__input--full" placeholder="Your Phone" v-model="data.telephone">

                                                        <span class="form__error" v-if="typeof errors.telephone != 'undefined'" v-html="errors.telephone"></span>
                                                    </div>
                                                    <div class="form__field">
                                                        <input type="file" class="form__input form__input--full" accept="application/msword, .pdf" name="cv" v-on:change="file($event, 'cv')" style="padding: 8px 15px" />

                                                        <span class="form__error" v-if="typeof errors.cv != 'undefined'" v-html="errors.cv"></span>
                                                    </div>
                                                    <button type="submit" class="btn btn--pill btn--lg btn--primary btn--teal btn--text--white">Apply Now</button>
                                                </div>
                                            </vue-form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </modal>
            </transition>
        </portal>
    </div>
</template>

<script>
export default {
    name: 'ApplyNowComponent',
    props: ['full', 'role', 'button', 'classes', 'description', 'qualifications', 'purpose', 'recaptcha'],

    data: () => ({
        modalOpen: false,
        career: {}
    }),

    methods: {
        toggle() {
            this.modalOpen = ! this.modalOpen
        }
    },
}
</script>



// WEBPACK FOOTER //
// ApplyNow.vue?9bdf6644